<template>
  <div class="comment-media-container">
    <div
      v-if="!commentMediaFile"
      class="camera-icon"
    >
      <b-tooltip
        v-if="!cloudinaryWidgetLoading"
        :label="$t('global.upload_photo_video')"
        position="is-top"
        type="is-dark"
      >
        <b-button
          class="plain-button camera-button"
          :disabled="isSavingComment"
          @click="openMediaWidget"
        >
          <camera-icon />
        </b-button>
      </b-tooltip>
      <spinner v-else />
    </div>
    <div
      v-else
      class="comment-media"
    >
      <media
        :media-file="commentMediaFile"
        :media-width="80"
      />
      <b-button
        class="plain-button remove-media"
        @click="removeMedia"
      >
        <delete-solid-icon />
      </b-button>
    </div>
  </div>
</template>

<script>
import CameraIcon from '@/components/icons/CameraIcon'
import Media from '@/components/Media.vue'
import DeleteSolidIcon from '../icons/DeleteSolidIcon.vue'
import Spinner from '../Spinner.vue'

export default {
  name: 'AddCommentMedia',
  components: {
    CameraIcon,
    DeleteSolidIcon,
    Media,
    Spinner
  },
  props: {
    cloudinaryWidgetLoading: {
      type: Boolean,
      required: true
    },
    commentMediaFile: {
      type: Object,
      default: null
    },
    isSavingComment: {
      type: Boolean,
      required: true
    },
    openMediaWidget: {
      type: Function,
      required: true
    },
    removeMedia: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .comment-media-container {
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .camera-button {
      width: 28px;
      height: 28px;

      svg {
        width: 23px;
        height: 23px;
        color: $blue;
      }
    }
  }

  .comment-media {
    position: relative;
    border: 2px solid $gray-light;
    border-radius: 3px;
    padding: 2px;

    .remove-media {
      position: absolute;
      right: -10px;
      top: -10px;
      background: rgba(0, 0, 0, 0.2);
      width: 20px;
      height: 20px;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      opacity: 0.7;

      svg {
        width: 12px;
        color: $black;
        display: block;
      }

      &:hover {
        background: $gray-dark;

        svg {
          color: #fff;
        }
      }
    }

    ::v-deep .media-container {
      margin: 0;
    }

    ::v-deep img {
      max-width: 50px;
      max-height: 50px;
      display: block;
    }
  }
</style>
